export const DEFAULT_PAGE = '/account';
